// eslint-disable-next-line no-useless-escape
export const YOUTUBE_LINK_REGEX = '((http:)?)(www\.)?((youtube\.comyoutu\.be)|(youtube)|(yandex))?(watch|embed|video).';
// export const YOUTUBE_LINK_REGEX =
// '((http:)?)(www\.)?((youtube\.comyoutu\.be)|(youtube)|(dzen))?(watch|embed|video).';

export function getYoutubeVideoId(url) {
  try {
    let videoId;
    const anchor = document.createElement('a');
    anchor.href = url;
    // Если есть query-параметры, то ищем в них. Иначе берем всю часть после слеша.
    if (anchor.search) {
      const queryStrings = anchor.search.substring(1);
      const urlParams = new URLSearchParams(queryStrings);
      videoId = urlParams.get('v');
    } else {
      videoId = anchor.pathname.substring(1);
    }
    return videoId;
  } catch {
    throw new Error('Ошибка при получении ID видео');
  }
}

export function getYoutubeEmbedLink(url, isImg) {
  try {
    // if (url.includes('dzen.')) {
    //   return 'https://dzen.ru/video/watch/64930861f482a55e5654eccf';
    // }

    const videoId = getYoutubeVideoId(url);
    if (isImg) {
      return `https://i3.ytimg.com/vi/${videoId}/maxresdefault.jpg`;
    }
    return `https://www.youtube.com/embed/${videoId}`;
  } catch {
    throw new Error('Ошибка при вставке видео');
  }
}

export default getYoutubeEmbedLink;
